import { render, staticRenderFns } from "./ApproveFile.vue?vue&type=template&id=833b17c6&scoped=true&"
import script from "./ApproveFile.vue?vue&type=script&lang=js&"
export * from "./ApproveFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833b17c6",
  null
  
)

export default component.exports